<template>
	<div>
		<img src="../../../public/pic/company/company2.png" style="vertical-align: middle;width: 100%;" />
		<div style="width: 90%;margin-top: 50px;" class="center_sun">
			<h1>{{ $t('lang.Contact1')}}</h1>
			<hr style="margin: 20px 0px;"/>
			<p style="text-align: left;margin-top: 40px;font-size: 16px;">
				<span style="font-size: 20px;">{{ $t('lang.buy2')}}</span><br/><br/>
				{{ $t('lang.Contact2')}}<br/><br/>
				{{ $t('lang.Contact3')}}<br/><br/>
				{{ $t('lang.Contact4')}}<br/><br/>
				{{ $t('lang.Contact5')}}<br/><br/>
				<span v-show="this.$i18n.locale == 'zh'">
					{{ $t('lang.Contact6')}}<br/><br/>
				</span>
				{{ $t('lang.Contact7')}}<br/><br/>
				{{ $t('lang.Contact8')}}<br/><br/>
				<span v-show="this.$i18n.locale == 'zh'">
					{{ $t('lang.Contact9')}}<br/><br/>
				</span>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '联系我们_深圳全智能机器人科技有限公司 。 Contact us------- Shenzhen All Intelligent Technology Co., Ltd.',
			keywords : '消毒机器人,迎宾机器人，陪护机器人,送餐机器人,硅胶实体娃娃,深圳全智能机器人科技有限公司。Disinfect robots, welcome robots, companion love robots, meal delivery robots, silicone solid dolls, Shenzhen All Intelligent Technology Co., Ltd.                        ',
			description : '深圳全智能机器人科技有限公司主要是主要是研发、生产、销售人工智能技术服务、软件、硬件平台和智能产品。产品可以广泛用于教育、军事、医疗、商务、交通、养老监护和智能家居等领域。公司所研发生产的迎宾机器人、情侣机器人、消毒机器人与送餐机器人等。全部可根据需求定制，提供专属的设计方案。AI-Tech is mainly focused on research and development, production and sales of artificial intelligence technology services, software, hardware platform and intelligent products. Products can be widely used in education, military, medical, business, transportation, old-age care and smart home and other fields. The company developed and produced welcome robots, companion robots, disinfection robots and meal delivery robots. All can be customized to meet the needs of the design.',
			};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
	img{
		width: 100%;
	}
</style>
